var map = {
	"./browsers/brave.svg": 58751,
	"./browsers/chrome.svg": 98885,
	"./browsers/edge.svg": 27272,
	"./browsers/firefox.svg": 12442,
	"./browsers/opera.svg": 4376,
	"./discord.svg": 17914,
	"./emote.svg": 96081,
	"./kick.svg": 94141,
	"./locales/ad.svg": 83796,
	"./locales/ae.svg": 9429,
	"./locales/af.svg": 68182,
	"./locales/ag.svg": 55303,
	"./locales/ai.svg": 90977,
	"./locales/al.svg": 65596,
	"./locales/am.svg": 19869,
	"./locales/ao.svg": 44623,
	"./locales/aq.svg": 18217,
	"./locales/ar.svg": 19482,
	"./locales/arab.svg": 41367,
	"./locales/as.svg": 22187,
	"./locales/at.svg": 60036,
	"./locales/au.svg": 37138,
	"./locales/aw.svg": 3159,
	"./locales/ax.svg": 27680,
	"./locales/az.svg": 35938,
	"./locales/ba.svg": 25264,
	"./locales/bb.svg": 82307,
	"./locales/bd.svg": 1597,
	"./locales/be.svg": 12124,
	"./locales/bf.svg": 91151,
	"./locales/bg.svg": 47422,
	"./locales/bh.svg": 89945,
	"./locales/bi.svg": 24552,
	"./locales/bj.svg": 75291,
	"./locales/bl.svg": 21781,
	"./locales/bm.svg": 49172,
	"./locales/bn.svg": 13735,
	"./locales/bo.svg": 33558,
	"./locales/bq.svg": 66880,
	"./locales/br.svg": 87635,
	"./locales/bs.svg": 82466,
	"./locales/bt.svg": 52685,
	"./locales/bv.svg": 32767,
	"./locales/bw.svg": 4334,
	"./locales/by.svg": 29880,
	"./locales/bz.svg": 80619,
	"./locales/ca.svg": 25095,
	"./locales/cc.svg": 98517,
	"./locales/cd.svg": 69418,
	"./locales/cefta.svg": 14882,
	"./locales/cf.svg": 6344,
	"./locales/cg.svg": 18713,
	"./locales/ch.svg": 1918,
	"./locales/ci.svg": 38319,
	"./locales/ck.svg": 64541,
	"./locales/cl.svg": 30610,
	"./locales/cm.svg": 33923,
	"./locales/cn.svg": 28176,
	"./locales/co.svg": 19297,
	"./locales/cp.svg": 67622,
	"./locales/cr.svg": 2148,
	"./locales/cu.svg": 86091,
	"./locales/cv.svg": 11672,
	"./locales/cw.svg": 37033,
	"./locales/cx.svg": 7246,
	"./locales/cy.svg": 38239,
	"./locales/cz.svg": 59212,
	"./locales/de.svg": 57458,
	"./locales/dg.svg": 24400,
	"./locales/dj.svg": 94741,
	"./locales/dk.svg": 33460,
	"./locales/dm.svg": 23114,
	"./locales/do.svg": 83720,
	"./locales/dz.svg": 69,
	"./locales/eac.svg": 72276,
	"./locales/ec.svg": 86879,
	"./locales/ee.svg": 14417,
	"./locales/eg.svg": 64595,
	"./locales/eh.svg": 74468,
	"./locales/er.svg": 31710,
	"./locales/es-ct.svg": 16077,
	"./locales/es-ga.svg": 6900,
	"./locales/es-pv.svg": 20822,
	"./locales/es.svg": 94287,
	"./locales/et.svg": 93168,
	"./locales/eu.svg": 91617,
	"./locales/fi.svg": 55932,
	"./locales/fj.svg": 34959,
	"./locales/fk.svg": 56030,
	"./locales/fm.svg": 69072,
	"./locales/fo.svg": 76274,
	"./locales/fr.svg": 93495,
	"./locales/ga.svg": 64939,
	"./locales/gb-eng.svg": 62927,
	"./locales/gb-nir.svg": 72596,
	"./locales/gb-sct.svg": 18097,
	"./locales/gb-wls.svg": 44359,
	"./locales/gb.svg": 26104,
	"./locales/gd.svg": 58374,
	"./locales/ge.svg": 45911,
	"./locales/gf.svg": 2788,
	"./locales/gg.svg": 57509,
	"./locales/gh.svg": 78690,
	"./locales/gi.svg": 41331,
	"./locales/gl.svg": 7886,
	"./locales/gm.svg": 28991,
	"./locales/gn.svg": 57292,
	"./locales/gp.svg": 41770,
	"./locales/gq.svg": 59611,
	"./locales/gr.svg": 78248,
	"./locales/gs.svg": 8550,
	"./locales/gt.svg": 10934,
	"./locales/gu.svg": 98055,
	"./locales/gw.svg": 52181,
	"./locales/gy.svg": 66627,
	"./locales/hk.svg": 45160,
	"./locales/hm.svg": 77846,
	"./locales/hn.svg": 19093,
	"./locales/hr.svg": 145,
	"./locales/ht.svg": 95903,
	"./locales/hu.svg": 74798,
	"./locales/ic.svg": 60659,
	"./locales/id.svg": 76620,
	"./locales/ie.svg": 56333,
	"./locales/il.svg": 22116,
	"./locales/im.svg": 76837,
	"./locales/in.svg": 55321,
	"./locales/io.svg": 65239,
	"./locales/iq.svg": 53057,
	"./locales/ir.svg": 48018,
	"./locales/is.svg": 85955,
	"./locales/it.svg": 27676,
	"./locales/je.svg": 70196,
	"./locales/jm.svg": 45660,
	"./locales/jo.svg": 11582,
	"./locales/jp.svg": 46697,
	"./locales/ke.svg": 27507,
	"./locales/kg.svg": 97233,
	"./locales/kh.svg": 29702,
	"./locales/ki.svg": 57412,
	"./locales/km.svg": 48171,
	"./locales/kn.svg": 90104,
	"./locales/kp.svg": 63998,
	"./locales/kr.svg": 98076,
	"./locales/kw.svg": 81377,
	"./locales/ky.svg": 87175,
	"./locales/kz.svg": 22612,
	"./locales/la.svg": 90806,
	"./locales/lb.svg": 79029,
	"./locales/lc.svg": 6420,
	"./locales/li.svg": 4670,
	"./locales/lk.svg": 69372,
	"./locales/lr.svg": 84357,
	"./locales/ls.svg": 33188,
	"./locales/lt.svg": 37867,
	"./locales/lu.svg": 6906,
	"./locales/lv.svg": 91369,
	"./locales/ly.svg": 61582,
	"./locales/ma.svg": 36773,
	"./locales/mc.svg": 28727,
	"./locales/md.svg": 39544,
	"./locales/me.svg": 43785,
	"./locales/mf.svg": 75674,
	"./locales/mg.svg": 90283,
	"./locales/mh.svg": 63404,
	"./locales/mk.svg": 42431,
	"./locales/ml.svg": 76544,
	"./locales/mm.svg": 12497,
	"./locales/mn.svg": 92130,
	"./locales/mo.svg": 97299,
	"./locales/mp.svg": 58836,
	"./locales/mq.svg": 31445,
	"./locales/mr.svg": 43222,
	"./locales/ms.svg": 23399,
	"./locales/mt.svg": 34216,
	"./locales/mu.svg": 99609,
	"./locales/mv.svg": 8234,
	"./locales/mw.svg": 84955,
	"./locales/mx.svg": 21788,
	"./locales/my.svg": 11261,
	"./locales/mz.svg": 57086,
	"./locales/na.svg": 66956,
	"./locales/nc.svg": 17550,
	"./locales/ne.svg": 80096,
	"./locales/nf.svg": 50995,
	"./locales/ng.svg": 88354,
	"./locales/ni.svg": 12452,
	"./locales/nl.svg": 70633,
	"./locales/no.svg": 71898,
	"./locales/np.svg": 72285,
	"./locales/nr.svg": 97039,
	"./locales/nu.svg": 31152,
	"./locales/nz.svg": 7719,
	"./locales/om.svg": 30983,
	"./locales/pa.svg": 79242,
	"./locales/pc.svg": 5224,
	"./locales/pe.svg": 30582,
	"./locales/pf.svg": 2453,
	"./locales/pg.svg": 29844,
	"./locales/ph.svg": 62979,
	"./locales/pk.svg": 5936,
	"./locales/pl.svg": 71823,
	"./locales/pm.svg": 28094,
	"./locales/pn.svg": 82269,
	"./locales/pr.svg": 14793,
	"./locales/ps.svg": 10552,
	"./locales/pt.svg": 99735,
	"./locales/pw.svg": 56612,
	"./locales/py.svg": 63138,
	"./locales/qa.svg": 67209,
	"./locales/re.svg": 90380,
	"./locales/ro.svg": 91462,
	"./locales/rs.svg": 61778,
	"./locales/ru.svg": 41436,
	"./locales/rw.svg": 57886,
	"./locales/sa.svg": 59735,
	"./locales/sb.svg": 55140,
	"./locales/sc.svg": 33157,
	"./locales/sd.svg": 98234,
	"./locales/se.svg": 3499,
	"./locales/sg.svg": 40169,
	"./locales/sh-ac.svg": 60031,
	"./locales/sh-hl.svg": 78787,
	"./locales/sh-ta.svg": 34826,
	"./locales/sh.svg": 29614,
	"./locales/si.svg": 67551,
	"./locales/sj.svg": 88524,
	"./locales/sk.svg": 23981,
	"./locales/sl.svg": 14690,
	"./locales/sm.svg": 45267,
	"./locales/sn.svg": 54528,
	"./locales/so.svg": 95089,
	"./locales/sr.svg": 66548,
	"./locales/ss.svg": 27829,
	"./locales/st.svg": 56202,
	"./locales/sv.svg": 16808,
	"./locales/sx.svg": 12382,
	"./locales/sy.svg": 74959,
	"./locales/sz.svg": 95932,
	"./locales/tc.svg": 35052,
	"./locales/td.svg": 41267,
	"./locales/tf.svg": 10993,
	"./locales/tg.svg": 96608,
	"./locales/th.svg": 48791,
	"./locales/tj.svg": 75237,
	"./locales/tk.svg": 77988,
	"./locales/tl.svg": 61931,
	"./locales/tm.svg": 68058,
	"./locales/tn.svg": 12873,
	"./locales/to.svg": 3864,
	"./locales/tr.svg": 40381,
	"./locales/tt.svg": 9763,
	"./locales/tv.svg": 11489,
	"./locales/tw.svg": 20368,
	"./locales/tz.svg": 74357,
	"./locales/ua.svg": 43293,
	"./locales/ug.svg": 47299,
	"./locales/um.svg": 66841,
	"./locales/un.svg": 22442,
	"./locales/us.svg": 9663,
	"./locales/uy.svg": 38181,
	"./locales/uz.svg": 39046,
	"./locales/va.svg": 99364,
	"./locales/vc.svg": 28102,
	"./locales/ve.svg": 53304,
	"./locales/vg.svg": 89434,
	"./locales/vi.svg": 77164,
	"./locales/vn.svg": 11059,
	"./locales/vu.svg": 47976,
	"./locales/wf.svg": 83956,
	"./locales/ws.svg": 60457,
	"./locales/xk.svg": 72632,
	"./locales/xx.svg": 18043,
	"./locales/ye.svg": 7293,
	"./locales/yt.svg": 1964,
	"./locales/za.svg": 74328,
	"./locales/zm.svg": 98188,
	"./locales/zw.svg": 24534,
	"./x.svg": 78981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57477;